import { useQuery } from '@tanstack/react-query';
import {
  getExperimentFeatures,
  validateExperimentationCsv,
} from '../services/experimentation';

export const useFetchExperimentationFeatures = () => {
  return useQuery(['experimentation-features'], () => getExperimentFeatures(), {
    initialData: [],
  });
};

export const useValidateExperimentationCsv = (file, featureName) => {
  return useQuery(
    ['validate-experimentation-csv', { file, featureName }],
    () => {
      const formData = new FormData();
      formData.append('csv_file', file);
      formData.append(
        'payload',
        JSON.stringify({
          feature_name: featureName,
        }),
      );
      return validateExperimentationCsv(formData);
    },
    {
      staleTime: 0,
      cacheTime: 0,
      enabled: !!file && !!featureName,
      networkMode: 'always',
    },
  );
};
